// components/CurrentInvestmentForm.js
import React, { useEffect, useState } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box
} from '@mui/material';
import { useAppContext } from '../context/AppContext';

function Debt() {
  const { state, actions } = useAppContext();
  
  const [value,setValues] = useState({
    bankBalance: state.bankBalance || '',
    fixedDeposit: state.fixedDeposit || '',
    retirementFund: state.retirementFund || '',
    bonds: state.bonds || '',
  });

  useEffect(() => {
    setValues(
      {
        bankBalance: state.bankBalance || '',
        fixedDeposit: state.fixedDeposit || '',
        retirementFund: state.retirementFund || '',
        bonds: state.bonds || '',
      }
    )
  }, [state.bankBalance, state.fixedDeposit, state.retirementFund, state.bonds])
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <Box>
      <CardContent>
      <Box sx={{ mb: 2}}>
      <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Bank Savings, Deposits & Bonds
          </Typography>
          <Typography variant="body1" component="h2" gutterBottom>
          Bank Balances (across all accounts)
          </Typography>
      
          <TextField
            // label="Bank Balance"
            value={formatNumber(value.bankBalance)}
            onChange={handleChange('bankBalance')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='total value of bank balance'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
        Fixed & Recurring Deposits (FD & RD)
        </Typography>
          <TextField
            // label="Fixed Deposit"
            value={formatNumber(value.fixedDeposit)}
            onChange={handleChange('fixedDeposit')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='total value of fixed income'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        
        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
         Retirement Accounts (PPF, EPF, NPS, etc)
        </Typography>
        
          <TextField
            // label="Retirement Funds"
            value={formatNumber(value.retirementFund)}
            onChange={handleChange('retirementFund')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='total value of retirement accounts'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
        Bonds & Debentures (RBI, Government, Bank, Corporate, etc)
        </Typography>
        
          <TextField
            // label="Retirement Funds"
            value={formatNumber(value.bonds)}
            onChange={handleChange('bonds')}
            fullWidth
            type="tel"
            inputMode="numeric"
            placeholder='total value of bonds & debentures'
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
      </CardContent>
</Box>
  );

}

export default Debt;